<template>
  <div
    class="login-content"
  >
    <div class="">
      <h5 class="card-title">
        B2B
      </h5>
      <form
        class=""
        @submit.prevent="onLogin"
      >
        <div class="form-group">
          <label for="username">
            {{ $t('common.username') }}
          </label>
          <input
            v-model="username"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label for="password">
            {{ $t('auth.password') }}
          </label>
          <input
            v-model="password"
            type="password"
            class="form-control"
          >
        </div>
        <div
          v-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <button
          :disabled="!canLogin"
          type="submit"
          class="btn btn-theme-add bg-secondary text-white"
        >
          {{ $t('auth.login') }}
        </button>
      </form>
    </div>
    <br>
    <p class="card-title">
      <a
              href="https://backend.doellken-profiles.pl/admin_1r3mrw/admin/auth/forgotpassword/"
      >Zresetuj hasło</a>
    </p>
  </div>
</template>

<style scoped>
  .login-content{
    color:#41362f;
    font-size:0.9rem;
  }
  .form-control{
    font-size:0.9rem;
  }
  .btn{
    font-size:0.9rem;
  }
  :root {
    --main-bg-color:#373330;
    --main-color: #e18d0b;
  }
  .form-control:focus{
    border-color: var(--main-color);
    -moz-box-shadow:    inset 0 0 4px var(--main-color);
    -webkit-box-shadow: inset 0 0 4px var(--main-color);
    box-shadow:         inset 0 0 4px var(--main-color);
  }
</style>

<script>
import { mapActions, mapState } from 'vuex'
import router from '../../../router';

export default {
   name: 'AuthForm',
   data() {
       return {
           username: '',
           password: '',
           error: ''
       }
   },
   computed: {
     ...mapState('auth', ['loading']),
     canLogin () {
       return this.username.length > 3 && this.password.length > 3
     }
   },
   methods: {
       ...mapActions('auth', ['Authenticate']),
       ...mapActions('auth', ['getUser']),
       onLogin () {
           this.Authenticate({
               username: this.username,
               password: this.password
           }).catch(res => {
             if (res.status === '401') {
               this.error = this.$t('auth.errors.authorization')
             } else {
               this.error = this.$t('auth.errors.network')
             }
           }).then(() => {
              this.getUser().then(function(results){
                router.push({
                    name: 'customer',
                    params: {
                        id: results.data.userCollection.allUserData[0].cardCode
                    }
                });
             }).catch(res => {
                if (res.status === '401') {
                  this.error = this.$t('auth.errors.authorization')
                } else {
                  this.error = this.$t('auth.errors.network')
                }
              });
           })
       }
   }
}
</script>
